import React from 'react';
export function IncludesSection() {
  const tomes = [{
    emoji: '🌱',
    title: 'Fundamentos',
    desc: 'Empieza sin errores'
  }, {
    emoji: '🌿',
    title: 'Plantación',
    desc: 'Qué y cómo plantar'
  }, {
    emoji: '🌼',
    title: 'Cuidado',
    desc: 'Plantas vivas y sanas'
  }, {
    emoji: '🐛',
    title: 'Plagas',
    desc: 'Protección natural'
  }, {
    emoji: '🏡',
    title: 'Espacios pequeños',
    desc: 'Balcones e interiores'
  }, {
    emoji: '📋',
    title: 'Sistema',
    desc: 'Organiza y mejora'
  }];
  return <section className="relative bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-62">
      <div className="max-w-6xl mx-auto" data-id="element-63">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-center text-[#1A1A1A] mb-10" data-id="element-64">
          📘 ¿Qué incluye exactamente?
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6" data-id="element-65">
          {tomes.map((tome, index) => <div key={index} className="bg-neutral-bg rounded-3xl p-6 text-center shadow-sm hover:shadow-xl transition-all duration-300 border border-neutral-beige group" data-id="element-66">
              <div className="w-16 h-16 mx-auto bg-white rounded-full flex items-center justify-center text-3xl mb-4 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-67">
                {tome.emoji}
              </div>
              <h3 className="text-xs font-black text-garden-medium uppercase tracking-widest mb-2" data-id="element-68">
                Tomo {index + 1}
              </h3>
              <p className="text-base sm:text-lg font-black text-[#1A1A1A] mb-2 leading-tight" data-id="element-69">
                {tome.title}
              </p>
              <p className="text-sm text-gray-600 font-medium leading-snug" data-id="element-70">
                {tome.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}